module.exports = __webpack_public_path__ + "img/ie.6a991632.svg";